module.exports = __webpack_public_path__ + "img/338465200079c4728560e1d2fb7337ee.14343b9f.png";